export default __webpack_public_path__ + "static/media/PerfNo2.e24814b6.png";